module.exports = __webpack_public_path__ + "static/media/proximanova-reg-webfont.06bd0e37.woff";


//////////////////
// WEBPACK FOOTER
// ./src/styles/resources/fonts/proximanova-reg-webfont.woff
// module id = 358
// module chunks = 0